import { html, css, SoloLitElement, unsafeHTML } from '@core/solo-lit-element';

import '@bog-design-system/bd-font';
import '@bog-design-system/bd-button';
import '@bog-design-system/bd-tooltip';

class soloResearchModal extends SoloLitElement {
  static get is() {
    return 'solo-research-modal-v2';
  }

  static get styles() {
    return css`
    :host {
        --btn-size: 40px;
        --btn-margin-size: var(--space-4);
    }

    :host([closed]) {
        margin-top: 0!important;
        --btn-margin-size: 0;
    }
        
    .wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: var(--btn-margin-size);
    }

    .main-container {
      width: 324px;
      background-color: var(--color-invert-background-solid-40);
      border-radius: var(--border-radius-32);
      display: none;
      padding:var(--space-12) var(--space-16) var(--space-16) var(--space-24);
      box-shadow: var(--shadow-popup);
    }
    
    :host([opened]) .main-container {
      display: block;
      transform: translate(-76px, 33%); 
    }

    :host([closed]) .main-container {
      display: none;
    }

    .image {
      width: 100%;
      height: auto;
    }

    .title, .description {
      color: var(--color-invert-component-tr-20);
    }

    .minimize {
      --icon-color: var(--color-invert-component-tr-50);
    }

    .button {
      border-radius: 100%;
      padding: 0;
      --padding: 0;
      box-sizing: border-box;
      width: calc(var(--btn-size) - var(--space-16));
      height: calc(var(--btn-size) - var(--space-16));
    }

    .header {
      display: flex;
      justify-content: space-between;
      margin-bottom: var(--space-12);
    }

    :host([opened]) .button-section{
      display:none;
    }

    :host([closed]) .button-section{
      display: none;
    }

    .footer {
      display: flex;
      margin-top: var(--space-24);
    }

    .redirect {
      margin-right: var(--space-8);
    }

    .button-wrapper {
      display: flex;
      align-items: center;
      background-color: var(--color-invert-background-solid-40);
      padding: var(--space-8);
      border-radius: 100%;
      box-shadow: var(--shadow-popup);
      cursor: pointer;
    }

    .button-wrapper:hover {
      background-color: var(--color-invert-background-solid-10);
    }

    .button-wrapper:active {
      background-color: var(--color-invert-background-solid-20);
    }

    @media(max-width: 600px) {
      .main-container {
        width: 280px;
      }

      :host([opened]) .main-container {
      display: block;
      transform: translate(0px, 0%); 
    }
    }

    `;
  }

  render() {
    return html`
      <div class="wrapper">
        <div id="main-container" class="main-container">
          <div class="header">
          <bd-font type="title" class="title">
            <span>${this.data?.title}</span>
          </bd-font>
          <bd-button type="black-uppercase" 
          icon-only icon="bd:subtract" 
          mini @click=${this.toggleModal}
          class="minimize"></bd-button>
          </div>
          <bd-font type="body2" class="description">
            ${unsafeHTML(this.data?.description)}
          </bd-font>
          <div class="footer">
            <bd-button .href="${this.url}"
            .target="${this.data?.redirectUrl?.target}"
            @click=${this.startResearch}
            class="redirect" mini>${this.data?.redirectButton}</bd-button>
            <bd-button type="primary-uppercase" @click=${this.closeModal} mini>${this.data?.closeButton}</bd-button>
          </div>
        </div>
        <div class="button-section">
          <bd-tooltip align="left" >
            <div class="button-wrapper" @click=${this.toggleModal}>
              <img class="image button" src='${this.data?.image?.url}' />
            </div>
            <bd-font
                type="xsmall-text"
                slot="text">
                ${this.data?.title}
            </bd-font>
          </bd-tooltip>
        </div>
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    this.apiCall('applications/leads/application-data/?contentType=App.Common.Research.Modal')
        .then((res) => {
          this.data=res.json.data;
          if (this.data.onlyMobile && this.isMobile || !this.data.onlyMobile) {
            this._openResearchModal();
          } else {
            this.closed = true;
            this.opened = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
  }

  _openResearchModal() {
    const percentage = parseInt(this.data.percent) || 0;
    const random = Math.floor(Math.random() * 100);
    const days = parseInt(this.data?.modalShowDays) || 0;
    const alreadyAppeared = JSON.parse(localStorage.getItem(this.data?.researchId));
    const currentDay = new Date();
    let available;
    if (alreadyAppeared) {
      // checks if x days are gone after appearing this modal button
      available = currentDay - days*24*60*60*1000 > new Date(alreadyAppeared.time).getTime();
    } else {
      available = true;
    }
    if ((random > percentage || !available)) {
      this.closed=true;
    } else {
      this.sendAnalyticsEvent(`research_bubble_loaded`, ``, 'research', true, true);
      this.getResearchUrl(random, this.data?.urls);
      const seconds = parseInt(this.data?.firstOpenSeconds) || 0;
      if (seconds > 0) {
        setTimeout(() => {
          this.opened = true;
          this.sendAnalyticsEvent(`research_bubble_pop_pup_first_view`, ``, 'research', true, true);
        }, seconds * 1000);
      } else {
        this.opened = true;
      }
    }
  }

  getResearchUrl(random, array) {
    if (this.data?.multipleUrls && array?.length) {
      const percent = parseInt(this.data?.percent) || 0;
      const dividedPercentages = percent / array.length;
      const index = Math.floor(random / dividedPercentages );
      this.url = array[index]?.url?.link;
      return;
    }
    this.url = this.data?.redirectUrl?.link;
  }

  // updated() {
  //   setTimeout(() => {
  //     this.tooltipVisible = !this.tooltipVisible;
  //   }, 5000);
  // }

  toggleModal() {
    this.opened = !this.opened;
    if (this.opened) {
      this.sendAnalyticsEvent(`research_bubble_clicked`, ``, 'research', true, true);
    } else {
      this.sendAnalyticsEvent(`research_bubble_minimized`, ``, 'research', true, true);
      const seconds = parseInt(this.data?.reOpenSeconds) || 0;
      if (seconds > 0) {
        setTimeout(() => {
          this.sendAnalyticsEvent(`research_bubble_pop_pup_auto_view`, ``, 'research', true, true);
          this.opened = true;
        }, seconds * 1000);
      }
    }
  }

  closeModal() {
    this.closed = true;
    this.opened = false;
    const currentDay = new Date();
    const storageObj = {
      value: true,
      time: currentDay,
    };
    localStorage.setItem(this.data?.researchId, JSON.stringify(storageObj));
    this.sendAnalyticsEvent(`research_bubble_closed`, ``, 'research', true, true);
  }

  startResearch() {
    this.sendAnalyticsEvent(`research_bubble_started`, ``, 'research', true, true);
  }

  constructor() {
    super();
    this.opened=false;
    this.closed=false;
    this.tooltipVisible = false;
  }

  static get properties() {
    return {
      data: {
        type: Object,
      },
      opened: {
        type: Boolean,
        reflect: true,
      },
      closed: {
        type: Boolean,
        reflect: true,
      },
      tooltipVisible: {
        type: Boolean,
      },
    };
  }
}

window.customElements.define(soloResearchModal.is, soloResearchModal);
